<div class="menu-navegacao-container-favorito">
  <mat-divider
    *ngIf="!(breakpointLg$ | async)"
    class="menu-divider"
    [vertical]="true"
  ></mat-divider>

  <div
    class="menu-button menu-button-favorito"
    mat-button
    type="button"
    cdkOverlayOrigin
    #favoritosOverlay="cdkOverlayOrigin"
    #favoritosViewOverlay
    [ngClass]="{ openedmenufavorito: isOverlayOpen }"
    (click)="overlayOpen()"
  >
    <mat-icon
      class="navegacao-menu-button-icon navegacao-menu-button-icon-favorito"
      svgIcon="star"
    ></mat-icon>
    <p class="noselect">Leis Favoritas</p>
    <mat-icon
      class="navegacao-menu-button-icon"
      [svgIcon]="isOverlayOpen ? 'caret-up' : 'caret-down'"
    ></mat-icon>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="favoritosOverlay"
  [cdkConnectedOverlayOpen]="isOverlayOpen"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayHasBackdrop]="true"
  (detach)="isOverlayOpen = false"
  (backdropClick)="overlayOpen()"
  [cdkConnectedOverlayPanelClass]="'navegacao-leis-favoritos-Overlay-custom'"
>
  <div class="navegacao-leis-favoritos-custom">
    <ng-container *ngIf="(listaFavoritos$ | async)?.length > 0; else Empty">
      <cdk-virtual-scroll-viewport
        itemSize="10"
        minBufferPx="200"
        maxBufferPx="400"
        class="navegacao-favoritos-virtual-scroll-viewport"
      >
        <app-item-navegacao-favoritos
          *cdkVirtualFor="let item of listaFavoritos$ | async"
          [item]="item"
          class="navegacao-favoritos-virtual-scroll-item"
          (favoritoMudou)="favoritoAlterardo($event)"
          (favoritoSelecionarLei)="selecionarLei($event)"
        >
        </app-item-navegacao-favoritos>
      </cdk-virtual-scroll-viewport>
    </ng-container>
  </div>
</ng-template>

<ng-template #Empty>
  <div class="navegacao-leis-favoritos-empty">
    <h4>Não existem itens para Leis Favoritas :(</h4>
  </div>
</ng-template>
